module.exports = __webpack_public_path__ + "img/课程思政.165c3c54.png";